import 'core-js/stable';
import 'regenerator-runtime/runtime';

import 'reflect-metadata';
import Vue, { VNode } from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import '@/registerServiceWorker';
import vuetify from '@/plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import '@/plugins/apexcharts';
import homeSmartApi from '@/plugins/HomeSmartApi';
import '@/plugins/vue-offline';
import '@/plugins/vee-validate';
import VuetifyConfirm from '@/plugins/vuetify-confirm';

import i18n from '@/plugins/i18n';

Vue.config.productionTip = false;

Vue.use(VuetifyConfirm, {
  vuetify,
  buttonTrueText: i18n.t('common.dialog.action.yes'),
  buttonFalseText: i18n.t('common.dialog.action.no'),
  color: 'error',
  buttonTrueColor: 'error',
  icon: 'mdi-alert-circle',
  title: i18n.t('common.dialog.title.confirmation')
});

(async (): Promise<void> => {
  homeSmartApi.rest.CheckOldToken();
  store.commit('app/auth/IsAuth', homeSmartApi.rest.IsAuth);

  if (homeSmartApi.rest.IsAuth) {
    await Promise.all([
      store.dispatch('app/auth/LoadInfo'),
      store.dispatch('dashboard/permissions/List')
    ]);
  } else {
    await store.dispatch('dashboard/permissions/List');
  }

  new Vue({
    i18n,
    router,
    store,
    vuetify,
    render: (h): VNode => h(App)
  }).$mount('#app');
})();
